import React from 'react'
import ContactComponent from '../components/contact.component'
import FooterComponent from '../components/footer.component'
import WhyComponent from '../components/why.component'
import useSEO from '../hooks/useSEO'

function Contact() {
    useSEO({
        title: 'Book Mehandi | Contact Mehandi Malabar – Kondotty, Malappuram',
        description: 'Book a mehandi appointment with Mehandi Malabar in Kondotty, Malappuram. Contact us for bridal, Arabic or traditional henna for your wedding or special event.',
        path: '/contact',
    });

    return (
        <div>
            <ContactComponent />
            <WhyComponent />
            <FooterComponent />
        </div>
    )
}

export default Contact
